import { useHasLegacyInvoices } from 'invoices/data/useHasLegacyInvoices';
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GlobalInvoiceContextType {
  showLegacyInvoices: boolean | null; // null means not yet determined
}

// Create the context
const GlobalInvoiceContext = createContext<GlobalInvoiceContextType | undefined>(undefined);

// Create a provider component
export const GlobalInvoiceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showLegacyInvoices, setShowLegacyInvoices] = useState<boolean | null>(null);

  useHasLegacyInvoices(setShowLegacyInvoices);
  return <GlobalInvoiceContext.Provider value={{ showLegacyInvoices }}>{children}</GlobalInvoiceContext.Provider>;
};

// Custom hook to use the context
export const useGlobalInvoiceContext = (): GlobalInvoiceContextType => {
  const context = useContext(GlobalInvoiceContext);
  if (!context) {
    throw new Error('useGlobalInvoiceContext must be used within a GlobalInvoiceProvider');
  }
  return context;
};
